import React from "react";
import { useSelector } from "react-redux";
import TextWrapper from "../../../../../../components/textWrapper/TextWrapper";
import { defaultProfileImage } from "../../../../../../constants/defaultUserImage";
import styles from "./oneChat.module.css";

const OneChat = ({ handleChatClick, chat }) => {
  const { activeChatId } = useSelector((state) => state.supportChat);

  return (
    <div
      className={
        chat?._id === activeChatId
          ? `${styles.chatUserWrapper} ${styles.active}`
          : styles.chatUserWrapper
      }
      onClick={() => handleChatClick(chat)}
    >
      <div className={styles.chatUser} key={chat?._id}>
        <div className={styles.userImageWrapper}>
          <img
            src={
              chat?.userId?.userImage?.path
                ? chat?.userId?.userImage?.path
                : defaultProfileImage
            }
            alt="user"
          />
        </div>
        <div className={styles.userNameMessage}>
          <TextWrapper textStyle={"textMid"}>{chat?.userId?.name}</TextWrapper>
          <TextWrapper textStyle={"textSmall"}>
            {chat?.lastMessage?.length > 60
              ? chat.lastMessage.slice(0, 60) + "..."
              : chat?.lastMessage}
          </TextWrapper>
        </div>
      </div>
      {chat?.unreadByAdminCount > 0 && (
        <div className={styles.unseenMessages}>
          <TextWrapper textStyle={"textMid"}>
            {chat?.unreadByAdminCount}
          </TextWrapper>
        </div>
      )}
    </div>
  );
};

function areEqual(prevProps, nextProps) {
  return (
    prevProps.chat._id === nextProps.chat._id &&
    prevProps.chat.lastMessage === nextProps.chat.lastMessage &&
    prevProps.handleChatClick === nextProps.handleChatClick
  );
}

export default React.memo(OneChat, areEqual);
